import { render, staticRenderFns } from "./AutomatorDefinePage.vue?vue&type=template&id=1499c066&scoped=true"
import script from "./AutomatorDefinePage.vue?vue&type=script&lang=js"
export * from "./AutomatorDefinePage.vue?vue&type=script&lang=js"
import style0 from "./AutomatorDefinePage.vue?vue&type=style&index=0&id=1499c066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1499c066",
  null
  
)

export default component.exports